import { Outlet } from "react-router-dom";

export type ReportesModule = {};

const ReportesModule: React.FC<ReportesModule> = () => {

  return <Outlet />;
};

export default ReportesModule;
